import React from "react";
import SecondaryStatsCard from "@/components/data-visuals/SecondaryStatsCard";
import { getChemistName } from "@/utils/textUtils";

const SecondaryStatsParent = ({ topPharmacy, topStaff }) => {
  return (
    <div className="flex flex-col space-y-1"> {/* Vertical spacing between cards */}
      <SecondaryStatsCard
        title="Top Pharmacy"
        value={topPharmacy?.TotalBookings || "N/A"}
        winner={getChemistName(topPharmacy?.chemistName) || "N/A"}
      />
      <SecondaryStatsCard
        title="Top Staff"
        value={topStaff?.TotalBookings || "N/A"}
        winner={topStaff?.StaffName || "N/A"}
      />
    </div>
  );
};

export default SecondaryStatsParent;
